import { FormatoFecha } from "../../../../utils/FormatFecha"
import { DEFAULT_COLOR_BG, COLOR_BG, COLOR_BG_BORDER, DEFAULT_COLOR_BG_BORDER } from "./colors"
export const dataGraficarCotizacionesAgente = ({ cotizacionesAgente, fecha }) => {
    const copyDetalleCotizacion = cotizacionesAgente ?? []
    const arrayOrdenado = copyDetalleCotizacion.sort((a, b) => {
        return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
    })
    const labels = [`${FormatoFecha({ date: fecha, formato: "MM/yyyy" })}`]
    const arrayData = arrayOrdenado.map((cotizacion, index) => {
        return {
            label: `${cotizacion?.catEstatusCotizacion?.Descripcion}`,
            data: [cotizacion?.total],
            backgroundColor: COLOR_BG[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG,
            borderColor: COLOR_BG_BORDER[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG_BORDER
        }
    })
    let data = {
        labels,
        datasets: arrayData
    }
    return data
}